import { render, staticRenderFns } from "./PayUnusalOrders.vue?vue&type=template&id=3a8b00b1&"
import script from "./PayUnusalOrders.vue?vue&type=script&lang=ts&"
export * from "./PayUnusalOrders.vue?vue&type=script&lang=ts&"
import style0 from "./PayUnusalOrders.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PayUnusalOrders.vue"
export default component.exports